module.exports = __webpack_public_path__ + "img/u1584.b31aba74.png";